import { render, staticRenderFns } from "./ClientInformationForm.vue?vue&type=template&id=370edf01&"
import script from "./ClientInformationForm.vue?vue&type=script&lang=js&"
export * from "./ClientInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports